@if (selectedProduct) {
  <div class="wrapper" [formGroup]="formGroup">
    <mds-select formControlName="productCode" [config]="{ options: options }" />
    <span class="title-s">
      <span class="nobold">{{ selectedProduct.currency }} </span>
      {{ selectedProduct.basePrice / 100 | currency: ' ' : 'code' : '1.0-0' : 'fr-CH' }}
    </span>
    @if (!isReadMode) {
      <ui-button
        mkpDataTest="select-cta-comparison-table-btn"
        [loading]="isProductLoading === selectedProduct.code"
        [config]="selectConfig"
        (click)="handleSelectedProduct.emit(selectedProduct.code)"
      >
        {{ 'PRODUCT_OFFERING.SELECT_PLAN' | translate }}
      </ui-button>
    }
  </div>
}
